export { ConfirmModal } from "./confirmModal";
//# sourceMappingURL=index.js.map